import { createIcon } from './icon-utils';

export const ForwardArrowIcon = createIcon({
  path: 'M18.627 12.75l-6.595 6.595c-.293.293-.293.767 0 1.06.293.293.768.293 1.06 0l7.876-7.875c.293-.293.293-.767 0-1.06l-7.875-7.875c-.293-.293-.768-.293-1.06 0-.294.293-.294.767 0 1.06l6.594 6.595H3.563c-.415 0-.75.336-.75.75s.335.75.75.75h15.064z',
});
